enum TrailStatus {
  Active = 'A',
  Deleted = 'D',
  Inactive = 'I',
  Pending = 'P'
}

export default TrailStatus;
